import { render, staticRenderFns } from "./MemberCrm.vue?vue&type=template&id=7867f5de&"
import script from "./MemberCrm.vue?vue&type=script&lang=ts&"
export * from "./MemberCrm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports